import React, { useEffect, useRef, useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import Axios from 'axios';
import { useSelector } from 'react-redux';
import { URL_LIST_ALL } from '../configs/api';
import { Modal } from "react-bootstrap";
import { confirmAlert } from 'react-confirm-alert';
import Spinner from '../component/Spinner';
import men_teacher from "../assets/img/men-teacher.png";
import girl_teacher from "../assets/img/girl-teacher.png";
import trau from "../assets/img/ic-bantin.png";
import configData from "../configs/config.json";

const CreatePost = ({ onPostCreated, listGroup }) => {
    const editorRef = useRef(null);
    const { user } = useSelector((state) => state.auth);

    const [loading, setLoading] = useState(false);
    const [modalFormPost, setModalFormPost] = useState(false);
    const [imagePreviews, setImagePreviews] = useState([]);
    const fileInputRef = useRef(null);
    const [refreshFile, setRefreshFile] = useState(false);
    const onlytype = 'image';
    const [uploading, setUploading] = useState(false);
    const [groupId, setGroupId] = useState(null);
    const [isVote, setIsVote] = useState(false);
    const [listVote, setListVote] = useState([]);
    const [metaTitle, setMetaTitle] = useState('');
    const [voteType, setVoteType] = useState('single');
    const [votePrivate, setVotePrivate] = useState(false);
    const [voteExpired, setVoteExpired] = useState(null);
    const [editorMounted, setEditorMounted] = useState(false);

    useEffect(() => {
        setEditorMounted(true); // chạy 1 lần khi mount
    }, []);

    const convertImageToBlobAfterResize = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const img = new Image();
                img.src = reader.result;
                img.onload = () => {
                    const maxSize = 2048;
                    const scale = Math.min(maxSize / img.width, maxSize / img.height, 1);
                    const canvas = document.createElement('canvas');
                    canvas.width = img.width * scale;
                    canvas.height = img.height * scale;
                    const ctx = canvas.getContext('2d');
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                    const outputType = file.type === "image/png" ? "image/png" : "image/jpeg";
                    canvas.toBlob((blob) => blob ? resolve(blob) : reject(new Error("Không thể resize ảnh")), outputType, 1);
                };
                img.onerror = reject;
            };
            reader.onerror = reject;
        });
    };

    const handleUploadImage = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        try {
            const resizedBlob = await convertImageToBlobAfterResize(file);
            const formData = new FormData();
            formData.append('file', resizedBlob, file.name);
            formData.append('changename', 1);
            formData.append('folder', 0);

            const res = await Axios.post(URL_LIST_ALL + 'fileupload', formData, user.config);
            if (res.data.status === 'success') {
                const imgTag = `<img src="${res.data.message}" alt="uploaded image" />`;
                editorRef.current?.insertContent(imgTag);
            } else {
                alert(`Upload thất bại: ${res.data.message}`);
            }
        } catch (err) {
            console.error('Lỗi upload ảnh:', err);
        }
    };

    const handleSubmit = () => {
        const content = editorRef.current?.getContent();
        if (!content || content.trim() === "") {
            alert("Vui lòng nhập nội dung bài viết");
            return;
        }

        setLoading(true);
        Axios.post(
            URL_LIST_ALL + 'posts',
            {
                user_id: user.data.id,
                type: 'normal',
                status: 1,
                post_content: content,
                list_images: imagePreviews,
                group_id: groupId,
                vote_expired: voteExpired,
                post_type: isVote ? (voteType === "single" ? "single_vote" : "multiple_vote") : null,
                post_meta: isVote && listVote.length > 0 ? listVote : null,
                vote_private: votePrivate
            },
            user.config
        ).then(res => {
            if (res.data.status == "success") {
                editorRef.current.setContent('');
                setModalFormPost(false);
                onPostCreated?.();
            } else {
                alert(res.data.message);
            }
        }).catch((e) => {
            // alert('Đăng bài thất bại');
        }).finally(() => setLoading(false));
    };

    const uploadProfilePic = async (e) => {
        const fileloads = e.target.files;
        if (!fileloads) return;

        const list_file = [];
        setUploading(true);
        const uploadPromises = Object.keys(fileloads).map(async (key) => {
            const fileload = fileloads[key];
            let file_name = fileload.name;
            if (onlytype && key >= 1) file_name = file_name.replace(onlytype, `_${key}${onlytype}`);
            const formData = new FormData();
            const resizedBlob = await convertImageToBlobAfterResize(fileload);
            formData.append('file', resizedBlob, file_name);
            formData.append('filename', file_name);
            formData.append('changename', 1);
            formData.append('folder', 0);
            return Axios.post(URL_LIST_ALL + 'fileupload', formData, user.config)
                .then(res => {
                    if (res.data.status === "success") {
                        list_file.push(res.data.message);
                        setImagePreviews(prev => [...prev, res.data.message]);
                    } else {
                        confirmAlert({ title: 'Lỗi', message: res.data.message, buttons: [{ label: 'OK' }] });
                    }
                })
                .catch((err) => console.error(err));
        });

        Promise.all(uploadPromises).then(() => {
            setUploading(false);
            setRefreshFile(!refreshFile);
        });
    };

    const convertYouTubeLinksToIframes = (html) => {
        return html.replace(
            /(?:<p>)?(https?:\/\/(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]+))(?:<\/p>)?/g,
            (_, __, videoId) => `
            <div class="youtube-embed">
              <iframe 
                src="https://www.youtube.com/embed/${videoId}"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>`
        );
    };

    const handleBlur = () => {
        const content = editorRef.current.getContent();
        const transformed = convertYouTubeLinksToIframes(content);
        if (content !== transformed) {
            editorRef.current.setContent(transformed);
        }
    };

    const addNewMeta = () => {
        if (!metaTitle.trim()) return;
        setListVote(prev => [...prev, metaTitle.trim()]);
        setMetaTitle('');
    };
    const removeVote = (indexToRemove) => setListVote(prev => prev.filter((_, i) => i !== indexToRemove));
    const handleEditVote = (index, value) => setListVote(prev => {
        const updated = [...prev];
        updated[index] = value.replace(/^(\d+\.\s)?/, '');
        return updated;
    });

    return (
        <div className="w-100 create-post">
            <div className="w-100 admin-img bg-white outer-form p-2 d-flex align-items-center border shadow mt-2" onClick={() => setModalFormPost(true)}>
                {user.data.avatar ? <img className='avatar' src={user.data.avatar + '&size=avatar'} alt="avatar" /> : <img className='avatar' src={user.data.sex === 'Nam' ? men_teacher : girl_teacher} alt="avatar" />}
                <strong className='ml-2'>Đăng tin vào Cộng đồng Blue <img src={trau} className='icon-post' alt='Cộng đồng Blue' /></strong>
            </div>
            <Modal show={modalFormPost} onHide={() => setModalFormPost(false)} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Đăng tin vào Cộng đồng Blue</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='w-100 modal-body-post'>
                        {editorMounted && (
                            <Editor
                                apiKey={configData.tiny_key}
                                onInit={(_, editor) => (editorRef.current = editor)}
                                onBlur={handleBlur}
                                init={{
                                    height: 300,
                                    menubar: false,
                                    plugins: ['advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview', 'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen', 'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount', 'emoticons'],
                                    toolbar: 'undo redo | blocks | bold italic forecolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | emoticons charmap | code | link | help',
                                    placeholder: 'Bạn đang nghĩ gì...',
                                }}
                            />
                        )}
                        <div className="upload-image-post mt-2">
                            <button className="btn btn-outline-info" onClick={() => fileInputRef.current.click()}>
                                <i className='fas fa-camera-retro'></i>
                            </button>
                            <input type="file" accept="image/*" ref={fileInputRef} style={{ display: 'none' }} onChange={handleUploadImage} />
                        </div>

                        <div className="row mt-3">
                            <div className='col-12 col-sm-6'>
                                <label className="btn btn-secondary">
                                    Tải lên hình ảnh
                                    <input type="file" accept="image/*" multiple hidden onChange={uploadProfilePic} />
                                </label>
                                <br />
                                {imagePreviews.map((src, index) => (
                                    <div key={index} style={{ position: "relative", display: "inline-block" }} className='mr-2'>
                                        <img src={src} alt={`preview-${index}`} style={{ width: 100, height: 100, objectFit: 'cover', borderRadius: 8 }} />
                                        <button
                                            type="button"
                                            onClick={() => setImagePreviews(pre => pre.filter((_, i) => i !== index))}
                                            style={{ position: 'absolute', top: -6, right: -6, background: 'red', borderRadius: '50%', color: 'white', width: 20, height: 20, fontSize: 12 }}
                                        >&times;</button>
                                    </div>
                                ))}
                                {uploading && <Spinner />}
                            </div>
                            <div className='col-12 col-sm-4 form-group'>
                                <select className="form-select height32" onChange={(e) => setGroupId(e.target.value)}>
                                    <option value={null}>Đăng lên tất cả</option>
                                    {listGroup && listGroup.map((gr, j) => <option key={j} value={gr.id}>{gr.title}</option>)}
                                </select>
                            </div>

                            {/* Các nút và options cho vote */}
                            <div className='col-12 col-sm-3 form-group'>
                                <button className="btn btn-sm" type='button' onClick={() => setIsVote(!isVote)}>
                                    <i className={isVote ? "fas fa-check-circle" : "far fa-circle"}></i> Tạo bình chọn
                                </button>
                            </div>
                            {isVote && (
                                <>
                                    <div className='col-12 col-sm-3 form-group'>
                                        <button className="btn btn-sm" type='button' onClick={() => setVoteType(voteType !== "single" ? "single" : "multiple")}>
                                            <i className={voteType !== "single" ? "fas fa-check-circle" : "far fa-circle"}></i> Cho phép chọn nhiều
                                        </button>
                                    </div>
                                    <div className='col-12 col-sm-3 form-group'>
                                        <button className="btn btn-sm" type='button' onClick={() => setVotePrivate(!votePrivate)}>
                                            <i className={votePrivate ? "fas fa-check-circle" : "far fa-circle"}></i> Ẩn danh
                                        </button>
                                    </div>
                                    <div className='col-12 col-sm-3 form-group'>
                                        <input className='form-control height32' placeholder='Thời hạn. VD: 12:00 27/08/2025' value={voteExpired || ''} onChange={e => setVoteExpired(e.target.value)} />
                                    </div>
                                    <div className='col-12 col-sm-6'>
                                        <div className="input-group mb-3">
                                            <input className="form-control height32" placeholder="Lựa chọn" value={metaTitle} onChange={e => setMetaTitle(e.target.value)} />
                                            <button className="btn btn-sm btn-success height32" type='button' onClick={addNewMeta}>Thêm</button>
                                        </div>
                                    </div>
                                    {listVote.map((iv, c) => (
                                        <div className='col-12 col-sm-6 mt-3' key={c}>
                                            <div className='vote-item input-group'>
                                                <input className='form-control height32' value={iv} onChange={e => handleEditVote(c, e.target.value)} />
                                                <button className='btn btn-sm btn-danger btn-trash' onClick={() => removeVote(c)}><span className='fas fa-trash-alt'></span></button>
                                            </div>
                                        </div>
                                    ))}
                                </>
                            )}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-primary" onClick={handleSubmit} disabled={loading}>{loading ? <Spinner /> : "Đăng tin"}</button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default CreatePost;
